<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 6V9.33333"
      stroke="#DC2626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.00028 14.2729H3.96028C1.64695 14.2729 0.680281 12.6195 1.80028 10.5995L3.88028 6.85287L5.84028 3.33287C7.02695 1.19287 8.97361 1.19287 10.1603 3.33287L12.1203 6.85954L14.2003 10.6062C15.3203 12.6262 14.3469 14.2795 12.0403 14.2795H8.00028V14.2729Z"
      stroke="#DC2626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99609 11.3333H8.00208"
      stroke="#DC2626"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.33333"
    />
  </svg>
</template>
